/**
 * Location Dialog Component
 * Add/Edit location modal
 */
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Loader2 } from "lucide-react";
import LocationAutocomplete from "../LocationAutocomplete";

export const LocationDialog = ({
  open,
  onOpenChange,
  locationForm,
  setLocationForm,
  editingLocation,
  saving,
  onSave
}) => {
  // Handle address selection from Google Places
  const handleAddressSelect = (placeData) => {
    setLocationForm({
      ...locationForm,
      address: placeData.address || placeData.formatted_address,
      name: locationForm.name || placeData.name || "",
      latitude: placeData.latitude,
      longitude: placeData.longitude,
      place_id: placeData.place_id
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-[28px] border-[#dfe6df] bg-[#fbfcf8] p-0 sm:max-w-xl">
        <DialogHeader>
          <div className="px-6 pt-6">
          <DialogTitle className="text-2xl text-[#102a27]">{editingLocation ? "Edit Location" : "Add Location"}</DialogTitle>
          <DialogDescription>
            {editingLocation ? "Update the venue details used across schedules." : "Search Google for a park, school, stadium, facility, or street address."}
          </DialogDescription>
          </div>
        </DialogHeader>
        <div className="space-y-5 bg-white px-6 py-6">
          <div className="space-y-2">
            <Label>Name *</Label>
            <Input
              value={locationForm.name}
              onChange={(e) => setLocationForm({...locationForm, name: e.target.value})}
              placeholder="e.g., Central Park Complex"
              className="rounded-xl"
            />
          </div>
          <div className="space-y-2">
            <Label>Address</Label>
            <LocationAutocomplete
              value={locationForm.address || ''}
              onChange={(value) => setLocationForm({...locationForm, address: value})}
              onPlaceSelect={handleAddressSelect}
              placeholder="Search locations or addresses"
              className="rounded-xl"
            />
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Textarea
              value={locationForm.notes}
              onChange={(e) => setLocationForm({...locationForm, notes: e.target.value})}
              placeholder="Parking info, access instructions..."
              className="rounded-xl"
              rows={2}
            />
          </div>
        </div>
        <DialogFooter className="px-6 pb-6">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-xl">Cancel</Button>
          <Button onClick={onSave} disabled={saving} className="rounded-xl bg-slate-900">
            {saving && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
            {editingLocation ? "Update" : "Add Location"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LocationDialog;
